import { Mode } from "@/ types";

export class AppFeatures {
    timer: {
        isRunning: boolean;
        current_mode: Mode;
        timeLeft: number;
        progress: number;
        completedPomodoros: number;
        currentDate: string;
        sessions: {
            id: string;
            completed: boolean;
            mode: Mode;
            time: number;
            timestamp: Date;
        }[];
    };

    CurrentSession: {
        id: string;
        startTime: number;
        time: number;
        mode: Mode;
    };

    settings: {
        pomodoro: { time: number; color: string };
        shortBreak: { time: number; color: string };
        longBreak: { time: number; color: string };
        longBreakInterval: number;
        autoStartBreaks: boolean;
        autoStartPomodoros: boolean;
        notifications: boolean;
    };

    tasks: {
        id: string;
        title: string;
        completed: boolean;
        pomodorosEstimated: number;
        pomodorosCompleted: number;
        createdAt: number;
        completedAt?: number;
    }[];



    constructor() {
        this.settings = {
            pomodoro: { time: 25, color: "#6B3F69" },
            shortBreak: { time: 5, color: "#556B2F" },
            longBreak: { time: 15, color: "#5D688A" },
            longBreakInterval: 4,
            autoStartBreaks: false,
            autoStartPomodoros: false,
            notifications: true
        };

        this.timer = {
            isRunning: false,
            current_mode: "pomodoro" as Mode,
            timeLeft: this.settings.pomodoro.time * 60, // Convert minutes to seconds
            progress: 0,
            completedPomodoros: 0,
            currentDate: new Date().toISOString().split('T')[0],
            sessions: []
        };

        this.CurrentSession = {
            id: "",
            startTime: 0,
            time: 0,
            mode: "pomodoro" as Mode
        };

        this.tasks = [];



    }
}